export const brandHeadingTextClassName = `font-bold text-xl`

export const brandHeadingTextClassName2xl = `font-bold text-2xl`

export const headingTextClassName =
  "text-black font-[700] antialiased text-[27px]"

export const paragraphTextClassName =
  "text-[#89888D] font-[400] text-[11pt] antialiased leading-[14pt] whitespace-pre-wrap"
